import angular, {
  ICompileService,
  IDirective,
  IScope,
  ITemplateLinkingFunction,
} from "angular";
import { vsServiceName as ChangeJournalViewItemServiceName } from "./service";
import { ChangeJournalViewItemService } from "./service";
import { kebabCase } from "lodash";
import { vsComponentName as ChangeJournalViewComponentName } from "../names";
import { ChangeJournalLogItem } from "../models";

export const vsDirectiveName = "changeJournalItemObjectDetail";

interface ChangeJournalItemObjectDetailScope extends IScope {
  logItem: ChangeJournalLogItem;
}

changeJournalItemObjectDetailDirective.$inject = [
  ChangeJournalViewItemServiceName,
  "$compile",
];
export function changeJournalItemObjectDetailDirective(
  changeJournalViewItemService: ChangeJournalViewItemService,
  $compile: ICompileService
): IDirective<ChangeJournalItemObjectDetailScope> {
  return {
    require: `^${ChangeJournalViewComponentName}`,
    restrict: "E",
    transclude: true,
    scope: {
      logItem: "<",
    },
    link: {
      pre(scope: ChangeJournalItemObjectDetailScope, element, attrs, ctrl) {
        const logItem = scope.logItem;
        const config = changeJournalViewItemService.getConfigObject(
          logItem.changeJournalRecord.ObjectName
        );

        if (!config) {
          throw new Error(
            "Can't find change journal config for " +
              logItem.changeJournalRecord.ObjectName
          );
        }

        const linkingFunction = getComponentLinkFunction(
          $compile,
          config.componentName
        );
        element?.empty();
        element?.append(linkingFunction(scope, () => {}));
      },
    },
  };
}

const itemLinkingFunctions: { [objectName: string]: ITemplateLinkingFunction } =
  {};

function getComponentLinkFunction(
  $compile: ICompileService,
  componentName: string
): ITemplateLinkingFunction {
  const cached = itemLinkingFunctions[componentName];
  if (cached) {
    return cached;
  }

  const kebabCaseName = kebabCase(componentName);
  const itemElement = angular.element(`<${kebabCaseName}></${kebabCaseName}>`);
  itemElement.attr("log-item", "logItem");

  return (itemLinkingFunctions[componentName] = $compile(itemElement));
}
